<template>
  <div class="subtitle">
    <div>
      {{ $t("walletVerification.subtitle_7_1") }} {{ accountAddress }}
      {{ $t("walletVerification.subtitle_7_2") }}
    </div>
    <div
      class="mt-4"
    >
      {{ $t("walletVerification.subtitle_8") }}
    </div>
    <div
      class="mt-2"
    >
      {{ $t("walletVerification.subtitle_9") }}
    </div>
    <div>{{ $t("walletVerification.subtitleNote") }}</div>

    <AuButton
      :disabled="statusChange"
      class="mt-2"
      type="primary"
      center
      width="200px"
      @click="$emit('openMetamaskAction')"
    >
      <div class="btn_metamask">
        {{ $t("walletVerification.btn_3") }}
      </div>
    </AuButton>
  </div>
</template>

<script>
import AuButton from "@/components/extended/AuButton.vue";

export default {
  name: "WalletChange",
  components: { AuButton },
  props: {
    accountAddress: {
      type: String,
      default: ""
    },
    statusChange: Boolean
  }
};
</script>
